import { mapState } from 'vuex';

const visitTree = (parent, next, level, name, callback) => {
   if (typeof next === "boolean") ; else if (typeof next === "string") {
      // parent[name] = next.replace("${images}", "TESTING");
      callback(parent, next, level, name);
      // console.log(tabs.substr(0, level), name, "string", parent[name]);
   } else if (Array.isArray(next)) {
      // console.log(tabs.substr(0, level), name, "array");
      next.map((item, index) => {
         visitTree(next, item, level + 1, index, callback);
      });
   } else if (typeof next === "object") {
      // console.log(tabs.substr(0, level), name, "object");
      const propNames = Object.keys(next);
      propNames.map((propName) => {
         const child = next[propName];
         visitTree(next, child, level + 1, propName, callback);
      });
      // console.log(propNames);
   } else if (typeof next === "number") ; else {
      console.log("UNKNOWN", name, next, typeof next);
   }
};

var script = {
   props: {
      componentLoader: {
         required: true,
         type: Function,
      },
      name: {
         required: false,
         type: String,
         default() {
            return "";
         },
      },
      bp: {
         required: false,
         type: String,
         default() {
            return null;
         },
      },
      copy: {
         required: false,
         type: [String, Object],
         default() {
            return null;
         },
      },
      minHeight: {
         required: false,
         type: Object,
         default() {
            return { xs: 40, sm: 40, md: 40, lg: 40, xl: 40 };
         },
      },
   },
   data() {
      return {
         loadedComponent: null,
         loadedCopy: null,
         observer: null,
         visible: false,
      };
   },
   computed: {
      ...mapState("viewport", ["breakpoint", "scroll"]),
      ...mapState("locale", ["locale"]),
      ...mapState("page", ["page"]),
      ...mapState("theme", ["theme"]),
   },
   watch: {
      locale(newValue) {
         // Reload copy if the locale changed
         this.loadCopy(this.loadedComponent);
      },
      async scroll(newValue) {
         if (!this.visible) {
            if (this.elementInViewport(this.$el)) {
               this.visible = true;
               await this.loadComponent();
            }
            // console.log(
            //    "scroll",
            //    this.scroll.y,
            //    this.name,
            //    this.elementInViewport(this.$el)
            // );
         }

         // console.log();
      },
      breakpoint(newValue) {
         // Check if component is now enabled in new breakpoint
         if (this.breakpointTest(newValue)) {
            // console.log('watch in breakpoint', newValue, this.observer, this.$el)
            if (this.visible === false) {
               this.observePlaceholder();
            } else if (this.loadedComponent) {
               this.loadCopy(this.loadedComponent);
            }
            //  else {
            //    await this.loadComponent();
            // }
         }
      },
   },
   // created() {
   // 	console.log(' ~~~~~~~~~~ created LazyContainer')
   // 	console.log('\t componentLoader', this.componentLoader, typeof this.componentLoader)
   // 	console.log('\t copy', this.copy)
   // 	console.log('\t bp', this.bp)
   // },
   async mounted() {
      if (this.breakpointTest(this.breakpoint)) {
         // Load component immediately if already visible
         if (this.elementInViewport(this.$el)) {
            // console.log("~~~~~~~~~~~~~ visible - load component", this.name);
            this.visible = true;
            await this.loadComponent();
         }
         // else {
         //    // Add observer to track component becomes visible to the user
         //    this.observePlaceholder();
         // }
      }
   },
   methods: {
      updateContentImageReferences(parent, next, level, name) {
         // Look for any content containing an image tag ${image}
         if (next.indexOf("${images}") !== -1) {
            // Update image path based on theme configuration
            let modifiedContent = next.replace(
               "${images}",
               this.theme.imagePath
            );

            // If the browser supported, change image extensions to webp for jpg, jpeg & png files

            const webp = this.$store.state.viewport.webp;

            if (webp) {
               modifiedContent = modifiedContent.replace(".jpg", ".webp");
               modifiedContent = modifiedContent.replace(".jpeg", ".webp");
               modifiedContent = modifiedContent.replace(".png", ".webp");
            }

            // Adjust file name if higher pixel density supported

            if (window.devicePixelRatio == 2) {
               modifiedContent = modifiedContent.replace("x1.", "x2.");
            }

            parent[name] = modifiedContent;
         }
      },

      elementInViewport(el) {
         // Very crude way to check if component is above the fold

         if (el.getBoundingClientRect !== undefined) {
            var rect = el.getBoundingClientRect();
            return rect.y < window.innerHeight;
         }

         // console.log(
         //    this.name,
         //    this.visible,
         //    el.getBoundingClientRect === undefined
         // );

         return false;
      },

      observePlaceholder() {
         if (this.observer === null) {
            this.observer = new IntersectionObserver(async (entries) => {
               // Use `intersectionRatio` to determine if component is within view (Edge 15 does not supprt `isIntersecting`)
               if (entries[0].intersectionRatio <= 0) return;
               // Stop observing the placeholder once it is in view
               this.observer.unobserve(this.$el);
               // Load dynamic copy
               // await this.loadCopy()
               // Load dynamic component
               // console.log("Load component");
               this.visible = true;
               console.log("LOADING - ", this.name);
               await this.loadComponent();
            }, {});
            // Start observing the placeholder
            if (this.$el instanceof Element) {
               this.observer.observe(this.$el);
            } else {
               console.log("UNABLE TO OBSERVE ELEMENT", this.$el);
            }
         }
      },

      breakpointTest(breakpoint) {
         // Check if current breakpoint is specified in component breakpoint (bp) list
         if (this.bp) {
            const breakpoints = this.bp.split(",");
            const inBreakpoint = breakpoints.indexOf(breakpoint) !== -1;
            return inBreakpoint;
         }

         // Always show component if breakpoints (bp) are absent
         return true;
      },

      async loadComponent() {
         // Load (import) component one time
         if (this.loadedComponent === null) {
            const loadedComponent = await this.componentLoader();
            await this.loadCopy(loadedComponent);
            await this.loadStore(loadedComponent);
            this.loadedComponent = loadedComponent;
         }
      },
      async loadStore(loadedComponent) {
         if (loadedComponent.storeLoader !== undefined) {
            const storeLoader = loadedComponent.storeLoader();
            const loadedStoreArray = await storeLoader();
            const loadedStore = loadedStoreArray[0];
            const moduleName = loadedStore.name;

            if (loadedStore.store) {
               const storeModule = await loadedStore.store();
               const store = this.$store;

               console.log(`LOADED STORE [${this.name}]`, {
                  moduleName,
                  storeModule: storeModule.default,
               });

               if (
                  !(
                     store &&
                     store.state &&
                     moduleName &&
                     store.state[moduleName]
                  )
               ) {
                  store.registerModule(moduleName, storeModule.default);
               }
            }
         }
      },
      async loadCopy(loadedComponent) {
         if (this.copy) {
            // Check if copy is a reference name or the actual JSON object
            if (typeof this.copy === "string") {
               // Parse copy string into default or breakpoint specific references
               const copyLookup = {};
               const copyArray = this.copy.split(",");
               copyArray.map((item) => {
                  const [left, right] = item.split(":");
                  if (right === undefined) {
                     copyLookup.default = left;
                  } else {
                     copyLookup[left] = right;
                  }
                  return null;
               });

               const copyId = copyLookup[this.breakpoint]
                  ? copyLookup[this.breakpoint]
                  : copyLookup.default;

               // Fetch from content JSON files from /public/content/copy

               const copyPath = this.theme.copyPath;
               const locale = this.$store.state.locale.locale;
               // const webp = this.$store.state.viewport.webp;

               this.loadedCopy = await fetch(
                  `${copyPath}/${locale}/${copyId}.json`,
                  {
                     method: "GET", // *GET, POST, PUT, DELETE, etc.
                     mode: "cors", // no-cors, cors, *same-origin
                     // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                     credentials: "same-origin", // include, *same-origin, omit
                     headers: {
                        "Content-Type": "application/json",
                     },
                     redirect: "follow", // manual, *follow, error
                     referrer: "no-referrer", // no-referrer, *client
                  }
               )
                  .then((response) => {
                     if (response.status === 404) {
                        console.log("404 RETURNED~~~~~~~~~~");
                        throw new Error("404");
                     }

                     return response.json();
                  })
                  // .then((copyText) => {
                  //    // Replace all instances of ${images} with themes image path

                  //    // var linksMatches = copyText.match(/\"LINKS\": {(.*?)}/g);

                  //    var linksMatches = copyText.match(/\"LINKS":([^}]+)}/g);

                  //    if (linksMatches) {
                  //       const linksString =
                  //          linksMatches[0].replace('"LINKS": ', "") + "}";
                  //       console.log("linksMatches", linksString);
                  //       const linksJSON = JSON.parse(linksString);
                  //       console.log(linksJSON);
                  //    }

                  //    // let revisedText = copyText.replace(
                  //    //   /\${images}/g,
                  //    //   this.theme.imagePath
                  //    // );

                  //    try {
                  //       // var matches = copyText.match(/\"\${images}(.*?)\.*"/g);
                  //       var matches = copyText.match(
                  //          /\"(.*?)\${images}(.*?)\"/g
                  //       );

                  //       if (matches) {
                  //          //   for (const match of matches) {
                  //          matches.map((match) => {
                  //             //  let revisedText = match.replace(
                  //             //    /\${images}/g,
                  //             //    this.theme.imagePath
                  //             //  );

                  //             // let modifiedMatch = match.replace(
                  //             //   /\${images}/g,
                  //             //   this.theme.imagePath
                  //             // );

                  //             let modifiedMatch = match.replace(
                  //                "${images}",
                  //                this.theme.imagePath
                  //             );

                  //             if (webp) {
                  //                modifiedMatch = modifiedMatch.replace(
                  //                   ".jpg",
                  //                   ".webp"
                  //                );
                  //                modifiedMatch = modifiedMatch.replace(
                  //                   ".jpg",
                  //                   ".webp"
                  //                );
                  //                modifiedMatch = modifiedMatch.replace(
                  //                   ".png",
                  //                   ".webp"
                  //                );
                  //             }

                  //             // copyText = copyText.replace(match, modifiedMatch);

                  //             // console.log("\t", match, modifiedMatch);

                  //             // console.log("\t", match, copyText);
                  //          });
                  //          //   }
                  //       }
                  //    } catch (err) {
                  //       console.log(
                  //          "error matching text",
                  //          err.message,
                  //          err.stack
                  //       );
                  //    }

                  //    // console.log("copyText", JSON.parse(copyText));

                  //    // console.log("~~~~~~~~matches", typeof matches, matches);

                  //    // matches.map(entry => {
                  //    //   console.log("\t", entry);
                  //    // });
                  //    const copyJSON = JSON.parse(copyText);

                  //    visitTree(
                  //       null,
                  //       copyJSON,
                  //       0,
                  //       "copyJSON",
                  //       this.updateImageContent
                  //    );

                  //    return copyJSON;
                  // })
                  .then((copyJSON) => {
                     // Recursively travel copy tree and update all link references
                     const links = copyJSON.LINKS;
                     if (links !== undefined) {
                        const linkNames = Object.keys(links);

                        visitTree(
                           null,
                           copyJSON,
                           0,
                           "copyJSON",
                           (parent, next, level, name) => {
                              if (next.indexOf(`{LINK|`) !== -1) {
                                 linkNames.map((linkName) => {
                                    if (
                                       next.indexOf(`{LINK|${linkName}}`) !== -1
                                    ) {
                                       const link = links[linkName];
                                       const content = `<a id="${link.id}" href="${link.url}">${link.content}</a>`;
                                       parent[name] = next.replace(
                                          `{LINK|${linkName}}`,
                                          content
                                       );
                                    }
                                 });
                              }
                           }
                        );
                     }

                     // Recursively travel copy tree and update all image references

                     visitTree(
                        null,
                        copyJSON,
                        0,
                        "copyJSON",
                        this.updateContentImageReferences
                     );
                     return copyJSON;
                  })
                  .catch((err) => {
                     console.log("ERROR LOADING IMAGE META DATA", err.message);
                     // return { err: err }
                  });
            } else if (typeof this.copy === "object") {
               // Set loaded copy state if component was given an object
               this.loadedCopy = this.copy;
            } else {
               console.log("copy was an unknown", this.name, typeof this.copy);
            }
         } else if (
            loadedComponent !== undefined &&
            loadedComponent.stubCopyLoader
         ) {
            // Load default copy if provided
            const stubCopyLoader = loadedComponent.stubCopyLoader();
            const loadedCopy = await stubCopyLoader();
            this.loadedCopy = loadedCopy.default;
         }
      },
   },
   render(createElement, context) {
      const inBreakpoint = this.breakpointTest(this.breakpoint);

      if (inBreakpoint && this.loadedComponent !== null) {
         // console.log("RENDER - ", this.name);

         const LazyComponent = this.loadedComponent.default;
         const copy = this.loadedCopy ? this.loadedCopy : null;
         // return <LazyComponent copy={copy} />;

         const combinedProps = { copy };

         // console.log("\t options", this.$options._propKeys);
         // const namedPropKeys = this.$options._propKeys;
         // const passedPropKeys = Object.keys(
         //    this.$options._parentVnode.data.props
         // );

         // Merge component specific props with combined props

         const passedProps = this.$options._parentVnode.data.props;
         const expectedProps = this.loadedComponent.default.props;

         Object.keys(expectedProps).map((propName) => {
            if (propName !== "copy" && passedProps[propName]) {
               // TODO - ADD PROP VALDATION HERE FOR ALL REQUIRED PROPS?
               combinedProps[propName] = passedProps[propName];
            }
         });

         // console.log("render", this.name, this.$slots.default);

         const children = [];

         if (this.$slots.default) {
            // console.log("\tgot slots");
            this.$slots.default.map((node) => {
               if (node.tag) {
                  children.push(createElement(node.tag));
               } else if (node.text) {
                  children.push(document.createTextNode(node.text));
               }
            });
         }

         return createElement(
            LazyComponent,
            { props: combinedProps },
            this.$slots.default
         );
      }

      const placeholderHeight = inBreakpoint
         ? this.minHeight[this.breakpoint]
         : null;

      const style = {
         color: "#aaa",
         border: "1px dotted #000",
         display: "flex",
         alignItems: "center",
         justifyContent: "center",
         width: "100%",
         height: placeholderHeight + "px",
         borderRadius: "12px",
         margin: "8px 0 0 0",
      };

      return createElement("div", { style }, this.name);

      // return (
      //    <div
      //       style={{
      //          color: "#ccc",
      //          border: "1px dotted #ccc",
      //          height: placeholderHeight
      //       }}
      //    >
      //       {this.name}
      //    </div>
      // );
   },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

var index = (props) => ({
   functional: true,
   render(h, context) {
      // console.log({ ...props }, context);
      const combinedProps = { ...props, ...context.data.attrs };
      return h(__vue_component__, { props: combinedProps }, context.children);
   },
});

export default index;
